import places from './words/Places';
import simple from './words/Simple';
import forbidden from './words/Forbidden';
import { Dictionary } from "./Dictionary";

export enum DictionaryName {
  PLACES = "places",
  SIMPLE = "simple",
  FORBIDDEN = "forbidden",
}

export const words = (dict: DictionaryName): Dictionary => {
  switch (dict) {
  case DictionaryName.PLACES:
    return places;
  case DictionaryName.SIMPLE:
    return simple;
  case DictionaryName.FORBIDDEN:
    return forbidden;
  default:
    return places;
  }
};
